import { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { fetchMeThunk } from '../redux/slices/authSlice';

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const sessionId = params.get('session_id');
  const { isAuthenticated, token } = useSelector((state) => state?.auth);

  useEffect(() => {
    if (!sessionId) {
      navigate('/login', { replace: true });
      return;
    }
    if (token) {
      dispatch(fetchMeThunk());
    }
    const timer = setTimeout(() => {
      if (token && isAuthenticated) {
        navigate('/app/settings', { replace: true });
      } else {
        navigate('/login', { replace: true });
      }
    }, 4500);

    return () => clearTimeout(timer);
  }, [sessionId, token, isAuthenticated, dispatch, navigate]);

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.iconSuccess}>✓</div>

        <h1 style={styles.title}>Payment Successful</h1>

        <p style={styles.subtitle}>
          {token ? (
            <>
              Your payment was completed successfully.
              <br />
              We’re activating your workspace now.
            </>
          ) : (
            <>
              Your payment was completed successfully.
              <br />
              Please sign in to access your workspace.
            </>
          )}
        </p>

        <div style={styles.loader} />

        <p style={styles.note}>
          Please don’t close this page.
          <br />
          You’ll be redirected automatically.
        </p>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#eef1ff',
    padding: 24,
  },
  card: {
    maxWidth: 420,
    width: '100%',
    background: '#ffffff',
    borderRadius: 14,
    padding: '40px 32px',
    textAlign: 'center',
    color: '#0f172a',
    boxShadow: '0 10px 30px rgba(15, 23, 42, 0.08)',
    border: '1px solid #e2e8f0',
  },
  iconSuccess: {
    width: 64,
    height: 64,
    margin: '0 auto 20px',
    borderRadius: '50%',
    background: '#4f46e5',
    color: '#ffffff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 32,
    fontWeight: 700,
  },
  title: {
    fontSize: 24,
    fontWeight: 700,
    marginBottom: 10,
  },
  subtitle: {
    fontSize: 15,
    color: '#475569',
    marginBottom: 28,
    lineHeight: 1.6,
  },
  loader: {
    width: 36,
    height: 36,
    margin: '0 auto 24px',
    borderRadius: '50%',
    border: '3px solid #e5e7eb',
    borderTop: '3px solid #4f46e5',
    animation: 'spin 1s linear infinite',
  },
  note: {
    fontSize: 13,
    color: '#64748b',
  },
};
